// @ts-nocheck
import $ from 'jquery';
import DateFormat from 'dateformat';

import NormalCC from '../images/Status/Alarms/NormalCC.png';
import MediumCC from '../images/Status/Alarms/MediumCC.png';
import LowCC from '../images/Status/Alarms/LowCC.png';
import HighCC from '../images/Status/Alarms/HighCC.png';
import HighALM from '../images/Status/Alarms/HighALM.png';
import MediumALM from '../images/Status/Alarms/MediumALM.png';

import AssetStateActive from '../images/AssetState/ActiveRA.svg';
import AssetStateDisconnected from '../images/AssetState/DisconnectedRA.png';
import AssetStateRetired from '../images/AssetState/RetiredRA.svg';

import TripInprogress from '../images/Status/RouteDeviation/TripInprogress.png';
import TripCompletedDeviation from '../images/Status/RouteDeviation/TripCompletedDeviation.png';
import TripCompleted from '../images/Status/RouteDeviation/TripCompleted.png';
import TripProblemetic from '../images/Status//RouteDeviation/TripProblemetic.png';
import TripPending from '../images/Status/RouteDeviation/TripPending.png';
import TripDeleted from '../images/Status/RouteDeviation/TripDeleted.png';
import TripCancelDeviation from '../images/Status/RouteDeviation/TripCancelDeviation.png';
import TripCancel from '../images/Status/RouteDeviation/TripCancel.png';
import lodashfilter from 'lodash/filter';

import passed from '../images/passed.png';
import aborted from '../images/aborted.png';
import runningtime from '../images/running-time.png';
import Skipped from '../images/Skipped.png';
import questionMark from '../images/questionMark.png';
import failed from '../images/failed.png';

const reeferFormatters = {

    CargoCareFormatter: (params) => {
        var valueString = "";
        var element = document.createElement("span");
        element.className = "reefer-alert";
        if (params != null && params != undefined && params != '') {

            var cellColor = "";
            var isCargoCare = false;
            var imageElement = document.createElement("img");

            if (params.data != null && params.data != undefined && params.data != '') {
                isCargoCare = params.data.IsCargoCare;

                if (params.data.CCAlarms != "" && params.data.CCAlarms != null && params.data.CCSeverityLevel != "" && params.data.CCSeverityLevel != null) {
                    if (params.data.CCSeverityLevel.toString() == "1") {
                        cellColor = "Tomato";
                    }
                    else if (params.data.CCSeverityLevel.toString() == "2") {
                        cellColor = "Orange";
                    }
                    else if (params.data.CCSeverityLevel.toString() == "3") {
                        cellColor = "Yellow";
                    }
                }
                else {
                    cellColor = "";
                }

                if (cellColor == "" && !isCargoCare) {
                    return "";
                }
                else if (isCargoCare && cellColor == "") {
                    imageElement.src = NormalCC;
                }
                else if (isCargoCare && cellColor == "Tomato") {
                    imageElement.src = HighCC;
                }
                else if (isCargoCare && cellColor == "Orange") {
                    imageElement.src = MediumCC;
                }
                else if (isCargoCare && cellColor == "Yellow") {
                    imageElement.src = LowCC;
                }
            }
            element.appendChild(imageElement);
        }

        return element;
    },

    CargoCareSorting: (params) => {
        var isCargoCare = false;
        var severity = "";
        if (params.data != null && params.data != undefined && params.data != '') {
            isCargoCare = params.data.IsCargoCare;
            severity = params.data.CCSeverityLevel;
            if (isCargoCare && severity == "1")
                return "1";
            else if (isCargoCare && severity == "2")
                return "2";
            else if (isCargoCare && severity == "3")
                return "3";
            else if (isCargoCare && severity == "")
                return "4";
            else if (severity == "" && !isCargoCare)
                return "5";
            else
                return "5";
        }
    },

    CargoCareFormatterForFilter: (params) => {

        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.CCAlarms != "" && params.data.CCAlarms != null && params.data.CCSeverityLevel != "" && params.data.CCSeverityLevel != null) {
                if (params.data.CCSeverityLevel.toString() == "1") {
                    return "Severe";
                }
                else if (params.data.CCSeverityLevel.toString() == "2") {
                    return "Minor";
                }
                else if (params.data.CCSeverityLevel.toString() == "3") {
                    return "Informational";
                }
                else if (params.data.CCSeverityLevel.toString() == "4") {
                    return "Assigned"; //RCNG-241 Renamed Normal to Assigned
                }
                else if (params.data.CCSeverityLevel.toString() == "5") {
                    return "";
                }
            }
        }
        return "";
    },

    statusIndicatorWithDescriptionForALM: (params, alarmsList) => {
        var element = document.createElement("span");
        element.className = "reefer-alert";
        if (params.value != null && params.value != undefined && params.value != '') {
            var imageElement = document.createElement("img");

            switch (params.value.trim()) {
                case '1':
                    imageElement.src = HighALM;
                    break;
                case '2':
                    imageElement.src = MediumALM;
                    break;
                default:
                    return "";

            }
            if (params.value.trim() == '1' || params.value.trim() == '2') {
                if (alarmsList != null && alarmsList != undefined && alarmsList.length > 0) {
                    if (params.data != null && params.data != undefined) {
                        var lstAlerts = params.data.AlarmsList.split(',');
                        var _alarmsList = "";
                        $.each(lstAlerts, function (index, item) {
                            if (item != "" && item != null) {
                                if (params.node.data.DeviceType != null && params.node.data.DeviceType != undefined && params.node.data.DeviceType.toString().trim() == "ST9100") {
                                    var alarmDescription = alarmsList.filter(e =>
                                        e.AlarmAlias === item && e.AlarmSeriesTypeCD.toString().toUpperCase().trim() === "K");
                                }
                                else {
                                var alarmDescription = alarmsList.filter(e =>
                                    e.AlarmAlias === item);
                                }
                                //var anchorElement = document.createElement("span");
                                var _alarmDesc = alarmDescription.length > 0 ? alarmDescription[0].Description.toString() : "";
                                _alarmsList = _alarmsList != "" ? _alarmsList + "\n" + item + " - " + _alarmDesc : item + " - " + _alarmDesc;
                                imageElement.title = _alarmsList;
                            }
                        });
                        element.appendChild(imageElement);
                    }
                }
            }
            return element;
        }

        return "";
    },
    EventDescriptionFormattersOld: (params, customerSpecificEventList, eventMasterList) => {
        var eventDesc = '-NA-';
        if (params != null && params != undefined && params.data != null && params.data != null && params.data != undefined) {
            var reeferOEMTypeCd = params.data.ReeferOEMTypeCd;
            if (params.data.EventMasterID != null && params.data.EventMasterID != "" && params.data.EventMasterID != "null") {
                var eventlist = lodashfilter(customerSpecificEventList, function (item) {
                    return item.EventMasterID === params.data.EventMasterID;
                });
                var custId = JSON.parse(sessionStorage.getItem('customerDetails')).CustomerId;
                var custSpecificEventList = lodashfilter(eventlist, function (item) {
                    return item.CustomerID === custId;
                });
                var finalcustSpecificEventList = lodashfilter(custSpecificEventList, function (item) {
                    return item.OEMType === reeferOEMTypeCd.toString().trim();
                });
                if (finalcustSpecificEventList != null && finalcustSpecificEventList.length) {
                    eventDesc = finalcustSpecificEventList.length > 0 ? finalcustSpecificEventList[0].EventDescription.toString() : "";
                }
                else {
                    var eventDescription = lodashfilter(eventMasterList, function (item) {
                        return item.EventMasterID === params.data.EventMasterID;
                    });
                    if (eventDescription.length > 0 && eventDescription != null) {
                        if (eventDescription[0].OverrideEventDesc != null) {
                            var OperationalEventParams = params.data.EventMasterID;
                            if (OperationalEventParams != null && OperationalEventParams != "") {
                                eventDesc = eventDescription[0].OverrideEventDesc + OperationalEventParams;
                            }
                        } else {
                            if (eventDescription[0].EventCd == "ATP" || eventDescription[0].EventCd == "UTP") {
                                if (params.data.CustCd3P != null && params.data.CustCd3P != "" && params.data.CustName3P != null && params.data.CustName3P != "") {
                                    return eventDesc = eventDescription[0].EventDescription + params.data.CustCd3P + " (" + params.data.CustName3P + ")";
                                }
                            }

                        }
                        return eventDesc = eventDescription[0].EventDescription;

                    }

                }
            }
            return eventDesc;
        }

        return eventDesc;
    },
    //WI-26422 - added 2 params
    EventDescriptionFormatters: (params, customerSpecificEventList, eventMasterList, M_CustomerAssetTypeDeviceTypeSensorAlerts, Ref_SensorAlerts) => {
        var eventDesc = '-NA-';
        if (params != null && params != undefined && params.data != null && params.data != undefined) {
            var reeferOEMTypeCd = params.data.ReeferOEMTypeCd == null ? "" : params.data.ReeferOEMTypeCd; // WI 26532
            if (params.data.EventMasterID != null && params.data.EventMasterID != "" && params.data.EventMasterID != "null") {
                var eventlist = lodashfilter(customerSpecificEventList, function (item) {
                    return item.EventMasterID === params.data.EventMasterID;
                });
                var custId = JSON.parse(sessionStorage.getItem('customerDetails')).CustomerId;
                var custSpecificEventList = lodashfilter(eventlist, function (item) {
                    return item.CustomerID === custId;
                });
                var finalcustSpecificEventList = lodashfilter(custSpecificEventList, function (item) {
                    return item.OEMType === reeferOEMTypeCd.toString().trim();
                });
                if (finalcustSpecificEventList != null && finalcustSpecificEventList.length) {
                    eventDesc = finalcustSpecificEventList.length > 0 ? finalcustSpecificEventList[0].EventDescription.toString() : "";
                }
                else {
                    var eventDescription = lodashfilter(eventMasterList, function (item) {
                        return item.EventMasterID === params.data.EventMasterID;
                    });

                /** WI-26422 - start */
                   
                    var resultSensorAlert = lodashfilter(Ref_SensorAlerts, function (item) {
                        return item.EventMasterID === params.data.EventMasterID;
                    });
                    if (resultSensorAlert != null && resultSensorAlert.length > 0) {

                        //WI-26422- to support devicetype 1020
                         var resultSensorAlertText = lodashfilter(M_CustomerAssetTypeDeviceTypeSensorAlerts, function (item) {
                             return item.SensorAlertCd === resultSensorAlert[0].SensorAlertCd && item.AssetTypeCd === "R"
                                 && item.DeviceTypeCd === params.data.DeviceType; 
                        });

                        //not possible, false case, probably revisit again
                        if (resultSensorAlertText != null && resultSensorAlertText.length === 0) {
                            if (resultSensorAlert != null && resultSensorAlert != "") {
                                return eventDesc = resultSensorAlert[0].MsgAlertText;
                            }
                        }
                        //WI-26451
                        if (resultSensorAlertText != null && resultSensorAlertText != "" && resultSensorAlertText.length === 1) {
                            return eventDesc = resultSensorAlertText[0].SensorAlertText;
                        }
                    }
                   
                    /** WI-26422 - end */

                    if (eventDescription.length > 0 && eventDescription != null) {
                        if (eventDescription[0].OverrideEventDesc != null && eventDescription[0].OverrideEventDesc == true) {
                            if (params.data.OEParams != null && params.data.OEParams != "" && params.data.OEParams.length > 0) { 
                                var OperationalEventParams = params.data.OEParams.trimEnd();
                                if (OperationalEventParams != null && OperationalEventParams != "") {
                                    return eventDescription[0].EventDescription + OperationalEventParams; //WI26438 Operational event not shown properly in Status Grid
                                }
                            }
                        }
                        else {
                            if (eventDescription[0].EventCd == "ATP" || eventDescription[0].EventCd == "UTP") {
                                if (params.data.CustCd3P != null && params.data.CustCd3P != "" && params.data.CustName3P != null && params.data.CustName3P != "") {
                                    return eventDesc = eventDescription[0].EventDescription + params.data.CustCd3P + " (" + params.data.CustName3P + ")";
                                }
                            }

                        }
                        return eventDesc = eventDescription[0].EventDescription;

                    }

                }
            }
            return eventDesc;
        }

        return eventDesc;
    },   
    DLEventDescriptionFormatters: (params, customerSpecificEventList, eventMasterList) => {
        var eventDesc = '-NA-';
        if (params != null && params != undefined && params.data != null && params.data != null && params.data != undefined) {
            var reeferOEMTypeCd = params.data.ReeferOEMTypeCd;
            if (params.data.DLEventMasterID != null && params.data.DLEventMasterID != "" && params.data.DLEventMasterID != "null") {
                var eventlist = lodashfilter(customerSpecificEventList, function (item) {
                    return item.EventMasterID === params.data.DLEventMasterID;
                });
                var custId = JSON.parse(sessionStorage.getItem('customerDetails')).CustomerId;
                var custSpecificEventList = lodashfilter(eventlist, function (item) {
                    return item.CustomerID === custId;
                });
                var finalcustSpecificEventList = lodashfilter(custSpecificEventList, function (item) {
                    return item.OEMType === reeferOEMTypeCd.toString().trim();
                });
                if (finalcustSpecificEventList != null && finalcustSpecificEventList.length) {
                    eventDesc = finalcustSpecificEventList.length > 0 ? finalcustSpecificEventList[0].EventDescription.toString() : "";
                }
                else {
                    var eventDescription = lodashfilter(eventMasterList, function (item) {
                        return item.EventMasterID === params.data.DLEventMasterID;
                    });
                    if (eventDescription.length > 0 && eventDescription != null) {                       
                        if (eventDescription[0].OverrideEventDesc != null && eventDescription[0].OverrideEventDesc == true) {
                            if (params.data.OEParams != null && params.data.OEParams != "" && params.data.OEParams.length > 0) {
                                var OperationalEventParams = params.data.OEParams.trimEnd();
                                if (OperationalEventParams != null && OperationalEventParams != "") {
                                    return eventDescription[0].EventDescription + OperationalEventParams; //WI26438 Operational event not shown properly in Status Grid
                                }
                            }
                        }
                        else {
                            if (eventDescription[0].EventCd == "ATP" || eventDescription[0].EventCd == "UTP") {
                                if (params.data.CustCd3P != null && params.data.CustCd3P != "" && params.data.CustName3P != null && params.data.CustName3P != "") {
                                    return eventDesc = eventDescription[0].EventDescription + params.data.CustCd3P + " (" + params.data.CustName3P + ")";
                                }
                            }

                        }
                        return eventDesc = eventDescription[0].EventDescription;

                    }

                }
            }
            return eventDesc;
        }

        return eventDesc;
    },
    PTIStateDescriptionFormatters: (params, preTripList) => {
        var ptiDescription = '-NA-';
        if (params != null && params != undefined && params.data != null && params.data != null && params.data != undefined) {
            var pretripTestStateID = params.data.PretripTestStateID;
            if (pretripTestStateID != null && pretripTestStateID != "" && pretripTestStateID != "null" && pretripTestStateID != 0) {
                //var pretripstateId = reeferFormatter.PreTripList.Where(e => e.PretripTestStateID.Equals(Convert.ToByte(PTStateVal))).ToList();
                var pretripstateId = lodashfilter(preTripList, function (item) {
                    return item.PretripTestStateID === pretripTestStateID;
                });
                if (pretripstateId != null && pretripstateId.length > 0) {
                    ptiDescription = pretripstateId[0].DisplayText;
                }
            }
            return ptiDescription;
        }

    },    
    FirmWareDescriptionFormatters: (params, FirmWareDescList, VersionType) => {
        var FirmWareDescription = '-NA-';
        var tempRoundingValue = "2";
        if (params != null && params != undefined && params.data != null && params.data != undefined) {
            var RCDFirmwareVersion = params.data.RCDFirmwareVersion;
            var DeviceType = params.data.DeviceType;

            if (RCDFirmwareVersion != null && RCDFirmwareVersion != "" && RCDFirmwareVersion != "null" && DeviceType != null && DeviceType != "") {
                var FWDescription = lodashfilter(FirmWareDescList, function (item) {
                    return item.ShortName.toUpperCase().trim() === RCDFirmwareVersion.toUpperCase().trim()
                        && item.FirmwareVersionType.toUpperCase().trim() === VersionType.toUpperCase().trim()
                        && item.DeviceTypeCD.toUpperCase().trim() === DeviceType.toUpperCase().trim();
                });
                if (FWDescription != null && FWDescription.length > 0) {
                    FirmWareDescription = FWDescription[0].LongName;
                }
                else
                    FirmWareDescription = params.data.RCDFirmwareVersion;
            }
            else {
                FirmWareDescription = '-NA-';

            }

            if ((DeviceType != null && DeviceType.trim() == "CT4000") && FirmWareDescription != '-NA-') {
                var tempVal = FirmWareDescription.split(" ");
                var param = tempVal[1];
                if (param != null && param != undefined) {
                    var val = parseFloat(param.toString());
                    var firmwareRev = tempVal[0] + " " + val.toFixed(parseInt(tempRoundingValue));
                    return firmwareRev;
                }
            }

            return FirmWareDescription;
        }

        return FirmWareDescription;
    },
    BootloaderFirmWareDescriptionFormatters: (params, FirmWareDescList, VersionType) => {
        var FirmWareDescription = '-NA-';
        if (params != null && params != undefined && params.data != null && params.data != null && params.data != undefined) {
            var RCDBootloaderVersion = params.data.RCDBootloaderVersion;
            var DeviceType = params.data.DeviceType;

            if (RCDBootloaderVersion != null && RCDBootloaderVersion != "" && RCDBootloaderVersion != "null" && DeviceType != null && DeviceType != "") {
                var FWDescription = lodashfilter(FirmWareDescList, function (item) {
                    return item.ShortName.toUpperCase().trim() === RCDBootloaderVersion.toUpperCase().trim()
                        && item.FirmwareVersionType.toUpperCase().trim() === VersionType.toUpperCase().trim()
                        && item.DeviceTypeCD.toUpperCase().trim() === DeviceType.toUpperCase().trim();
                });
                if (FWDescription != null && FWDescription.length > 0) {
                    FirmWareDescription = FWDescription[0].LongName;
                }
                else
                    FirmWareDescription = params.data.RCDBootloaderVersion;
            }
            else {
                FirmWareDescription = '-NA-';

            }
            return FirmWareDescription;
        }
        return FirmWareDescription;
    },
    MeshFirmWareDescriptionFormatters: (params, FirmWareDescList, VersionType) => {
        var FirmWareDescription = '-NA-';
        if (params != null && params != undefined && params.data != null && params.data != null && params.data != undefined) {
            var RCDMeshFirmwareVersion = params.data.RCDMeshFirmwareVersion;
            var DeviceType = params.data.DeviceType;

            if (RCDMeshFirmwareVersion != null && RCDMeshFirmwareVersion != "" && RCDMeshFirmwareVersion != "null" && DeviceType != null && DeviceType != "") {
                var FWDescription = lodashfilter(FirmWareDescList, function (item) {
                    return item.ShortName.toUpperCase().trim() === RCDMeshFirmwareVersion.toUpperCase().trim()
                        && item.FirmwareVersionType.toUpperCase().trim() === VersionType.toUpperCase().trim()
                        && item.DeviceTypeCD.toUpperCase().trim() === DeviceType.toUpperCase().trim();
                });
                if (FWDescription != null && FWDescription.length > 0) {
                    FirmWareDescription = FWDescription[0].LongName;
                }
                else
                    FirmWareDescription = params.data.RCDMeshFirmwareVersion;
            }
            else {
                FirmWareDescription = '-NA-';
            }
            return FirmWareDescription;
        }
        return FirmWareDescription;
    },

    UnitTypesListFormatters: (params, UnitTypesList) => {
        var UnitTypeCdDescription = '-NA-';
        if (params != null && params != undefined && params.data != null && params.data != undefined) {
            var UnitTypeCd = params.data.UnitTypeCd;

            if (UnitTypeCd != null && UnitTypeCd != "" && UnitTypeCd != 0) {
                var UnitTypeCdId = lodashfilter(UnitTypesList, function (item) {
                    return item.UnitTypeCd === UnitTypeCd;
                });
                if (UnitTypeCdId != null && UnitTypeCdId.length > 0) {
                    UnitTypeCdDescription = UnitTypeCdId[0].ColumnDisplay;
                }
            }
        }

        return UnitTypeCdDescription;
    },

    ControllerTypeCdFormatters: (params, ControllerTypeList) => {
        var ControllerTypeCdDescription = '-NA-';
        if (params != null && params != undefined && params.data != null && params.data != undefined) {
            var ControllerTypeCd = params.data.ControllerTypeCd;

            if (ControllerTypeCd != null && ControllerTypeCd != "" && ControllerTypeCd != 0) {
                var ControllerTypeCdId = lodashfilter(ControllerTypeList, function (item) {
                    return item.ControllerTypeCd === ControllerTypeCd;
                });
                if (ControllerTypeCdId != null && ControllerTypeCdId.length > 0) {
                    ControllerTypeCdDescription = ControllerTypeCdId[0].ColumnDisplay;
                }
            }
        }

        return ControllerTypeCdDescription;
    },


    statusALMSorting: (params) => {

        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.MASeverityLevel != null && params.data.MASeverityLevel != undefined && params.data.MASeverityLevel != "") {
                switch (params.data.MASeverityLevel.trim()) {
                    case '1':
                        return "1";
                    case '2':
                        return "2";
                    default:
                        return "3";
                }
            }
        }
        return "3";
    },

    statusIndicatorWithDescriptionForALMForFilter: (params) => {
        var title = "";
        switch (params.data.MASeverityLevel.trim()) {
            case '1':
                title = "Severe";
                break;
            case '2':
                title = "Minor";
                break;
            default:
                title = "";
                break;
        }
        //if (alarmsList != null && alarmsList != undefined && alarmsList.length > 0) {
        //    if (params.data != null && params.data != undefined) {
        //        var lstAlerts = params.data.AlarmsList.split(',');
        //        var _alarmsList = "";
        //        $.each(lstAlerts, function (index, item) {
        //            if (item != "" && item != null) {
        //                var alarmDescription = alarmsList.filter(e =>
        //                    e.AlarmAlias === item);
        //                var _alarmDesc = alarmDescription.length > 0 ? alarmDescription[0].Description.toString() : "";
        //                _alarmsList = _alarmsList != "" ? _alarmsList + "\n" + item + " - " + _alarmDesc : item + " - " + _alarmDesc;
        //                title = _alarmsList;
        //            }
        //        });
        //    }
        //}

        return title;
    },

    runStateFormatter: (params) => {
        if (params.data != null && params.data != undefined) {
            if (params.data.RunState != null && params.data.RunState != undefined) {
                if ((params.data.RunState.toString().toUpperCase().trim()) == 'I')
                    return params.value = '<span title="Running" class="fas fa-power-off GridIcons greenText"></span>';

                else if ((params.data.RunState.toString().toUpperCase().trim()) == 'S')
                    return params.value = '<span title="Standby" class="fas fa-power-off GridIcons greytext"></span>';

                else if ((params.data.RunState.toString().toUpperCase().trim()) == 'X')
                    return params.value = '<span title="Faulty" class="fas fa-power-off GridIcons orangetext"></span>';


                else if ((params.data.RunState.toString().toUpperCase().trim()) == 'O')
                    return params.value = '<span title="Offline" class="fas fa-horizontal-rule"></span>';

                else
                    return '-NA-';

            }

            return '-NA-';
        }
    },

    assetStateFormatter: (params) => {
        var element = document.createElement("span");

        if (params.data != null && params.data != undefined) {
            var imageElement = document.createElement("img");
            if (params.data.AssetState != null && params.data.AssetState != undefined) {
                var assetState = params.data.AssetState;                
                switch (assetState.toUpperCase().trim()) {
                    case 'A':
                        element.className = "ActiveRA";
                        imageElement.src = AssetStateActive;
                        element.title = "Active";
                        break;
                    case 'D':
                        element.className = "DisconnectedRA";
                        imageElement.src = AssetStateDisconnected;
                        element.title = "Disconnected";
                        break;
                    case 'R':
                        element.className = "RetiredRA";
                        imageElement.src = AssetStateRetired;
                        element.title = "Retired";
                        break;
                    default:
                        break;

                }
            }

            element.appendChild(imageElement);
            return element;
        }

        return '-NA-';
    },

    RunstateSorting: (params) => {
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.RunState != null && params.data.RunState != "" && params.data.RunState != undefined) {
                if (params.data.RunState == 'X')
                    return "1";
                else if (params.data.RunState == 'I')
                    return "2";
                else if (params.data.RunState == 'S')
                    return "3";
                else if (params.data.RunState == 'O')
                    return "4";
                else
                    return "5";
            }
            return "5";
        }
    },

    runStateFormatterForFilter: (params) => {
        if (params.data != null && params.data != undefined) {
            if (params.data.RunState != null && params.data.RunState != undefined) {
                if ((params.data.RunState.toString().toUpperCase().trim()) == 'I')
                    return "Running";

                else if ((params.data.RunState.toString().toUpperCase().trim()) == 'S')
                    return "Standby";

                else if ((params.data.RunState.toString().toUpperCase().trim()) == 'X')
                    return "Faulty";


                else if ((params.data.RunState.toString().toUpperCase().trim()) == 'O')
                    return "Offline";

                else
                    return '-NA-';

            }

            return '-NA-';
        }
    },    

    TripstatusIndicator: (params) => {
        var element = document.createElement("span");
        element.className = "reefer-alert";
        var deviationFlg = '';
        if (params.value != null && params.value != undefined && params.value != '' && params.value != '-NA-') {
            var imageElement = document.createElement("img");
            var valueString = params.value.toString();
            var arrList = valueString.split(':');
            if (arrList.length == 2) {
                var cLogStatusvalue = arrList[0];
                deviationFlg = arrList[1];
                switch (cLogStatusvalue.toUpperCase().trim()) {
                    case 'A':
                        imageElement.src = TripInprogress;
                        break;
                    case 'C':
                        if (deviationFlg == "True")
                            imageElement.src = TripCompletedDeviation; /* WI19591 checking Trip is deviated */
                        else
                            imageElement.src = TripCompleted;
                        break;
                    case 'D':
                        imageElement.src = TripProblemetic;
                        break;
                    case 'P':
                        imageElement.src = TripPending;
                        break;
                    case 'R':
                        imageElement.src = TripDeleted;
                        break;
                    case 'X':
                        if (deviationFlg == "True")
                            imageElement.src = TripCancelDeviation; /* WI19591 checking Trip is deviated */
                        else
                            imageElement.src = TripCancel;
                        break;
                    default:
                        break;

                }
            }

            element.appendChild(imageElement);
            return element;
        }
        return '-NA-';
    },

    TripSorting: (params) => {
        if (params != null && params != undefined) {
            if (params.data != undefined && params.data != null) {
                if (params.data.TripStatusCdAndDFlag != null && params.data.TripStatusCdAndDFlag != undefined) {
                    return params.data.TripStatusCdAndDFlag;
                }
            }
        }

        return '-NA-';
    },

    OEMTypeValueFormatterFieldName: (params) => {

        var oemType = "-NA-";
        if (params != null && params != undefined) {
            if (params.data != null && params.data != undefined) {
                if (params.data.ReeferOEMTypeCd != null && params.data.ReeferOEMTypeCd != undefined) {
                    switch (params.data.ReeferOEMTypeCd.toString().toUpperCase().trim()) {
                        case "C":
                            oemType = "CAR";
                            break;
                        case "D":
                            oemType = "DKN";
                            break;
                        case "S":
                            oemType = "SC";
                            break;
                        case "T":
                            oemType = "TK";
                            break;
                        case "G":
                            oemType = "GMK";
                            break;
                        case "TA":
                            oemType = "TLR";
                            break;
                        case "U":
                            oemType = "UNK";
                            break;
                        case "K":
                            oemType = "KLINGE";
                            break;
                        case "CARRIER":
                            oemType = "CAR";
                            break;
                        case "DAIKIN":
                            oemType = "DKN";
                            break;
                        case "STARCOOL":
                            oemType = "SC";
                            break;
                        case "THERMOKING":
                            oemType = "TK";
                            break;
                        case "GENMARK":
                            oemType = "GMK";
                            break;
                        case "TAYLOR":
                            oemType = "TLR";
                            break;
                        case "UNKNOWN":
                            oemType = "UNK";
                            break;
                        case "OEM_KLINGE":
                            oemType = "KLINGE";
                            break;
                        default:
                            oemType = '-NA-'
                    }
                }
                else
                    oemType = '-NA-';
            }
            else
                oemType = '-NA-';
        }
        else
            oemType = '-NA-';

        return oemType;
    },

    oemTypeFormatterForFilter: (params) => {

        var oemType = '';
        if (params != null && params != undefined && params.data != null && params.data != undefined && params.data.ReeferOEMTypeCd != null && params.data.ReeferOEMTypeCd != undefined) {
            switch (params.data.ReeferOEMTypeCd.toString().toUpperCase().trim()) {
                case "C":
                    oemType = "CAR";
                    break;
                case "D":
                    oemType = "DKN";
                    break;
                case "S":
                    oemType = "SC";
                    break;
                case "T":
                    oemType = "TK";
                    break;
                case "G":
                    oemType = "GMK";
                    break;
                case "TA":
                    oemType = "TLR";
                    break;
                case "U":
                    oemType = "UNK";
                    break;
                case "K":
                    oemType = "KLINGE";
                    break;
                case "CARRIER":
                    oemType = "CAR";
                    break;
                case "DAIKIN":
                    oemType = "DKN";
                    break;
                case "STARCOOL":
                    oemType = "SC";
                    break;
                case "THERMOKING":
                    oemType = "TK";
                    break;
                case "GENMARK":
                    oemType = "GMK";
                    break;
                case "TAYLOR":
                    oemType = "TLR";
                    break;
                case "UNKNOWN":
                    oemType = "UNK";
                    break;
                case "KLINGE":
                    oemType = "KLINGE";
                    break;
                default:
                    oemType = '-NA-';
            }
        }
        else oemType = "-NA-";
        return oemType;
    },

    TemperatureFormatterForBooking: (params) => {
        var tempRoundingValue = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureRoundPrecision;
        var tempUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim();
        var BookedTemperature = null;
        var TempUnit = null;
        if (params.value != null && params.value != '-NA-') {            
            var strlstValues = params.value.split('@');
            BookedTemperature = strlstValues[0];
            TempUnit = strlstValues[1];
            if (TempUnit.toUpperCase() == "N")
                return "Non-Running";
            else if (TempUnit.toUpperCase() != tempUnitCd.toUpperCase()) {
                if ("F" == tempUnitCd.toUpperCase()) {
                    var tempValue = parseFloat(BookedTemperature.toString());
                    tempValue = ((tempValue * 9) / 5) + 32;
                    var param = parseFloat(tempValue.toString());  
                    //26515 - commented and added
                    //return parseFloat(param.toFixed(parseInt(tempRoundingValue)));
                    return tempRoundingValue > 0 ? param.toFixed(parseInt(tempRoundingValue)).toString() === "-0.0" ? parseFloat("0.0").toFixed(1) :
                        param.toFixed(parseInt(tempRoundingValue)) : param.toFixed(1);
                }
                else {
                    var tempValue = parseFloat(BookedTemperature.toString());
                    tempValue = (tempValue - 32) * 5 / 9;
                    var param = parseFloat(tempValue.toString());              
                    //26515 - commented and added
                    //return parseFloat(param.toFixed(parseInt(tempRoundingValue)));
                    return tempRoundingValue > 0 ? param.toFixed(parseInt(tempRoundingValue)).toString() === "-0.0" ? parseFloat("0.0").toFixed(1) :
                        param.toFixed(parseInt(tempRoundingValue)) : param.toFixed(1);
                }
            }
            else {
                //26515 - commented and added
                //return parseFloat(parseFloat(BookedTemperature.toString()).toFixed(parseInt(tempRoundingValue)));
                var tempValue = parseFloat(BookedTemperature.toString());
                var param = parseFloat(tempValue.toString());
                return tempRoundingValue > 0 ? param.toFixed(parseInt(tempRoundingValue)).toString() === "-0.0" ? parseFloat("0.0").toFixed(1) :
                    param.toFixed(1) : "";               
            }
        }
        else
            return '-NA-';
    },

    TemperatureSortingFieldName: (params, FieldName) => {
        if (params != null && params != undefined) {
            if (params.data != undefined && params.data != null) {

                switch (FieldName) {
                    case 'RunningMode':
                        return params.data.RunningMode != null && params.data.RunningMode != "" && params.data.RunningMode != "null" ? params.data.RunningMode : '-NA-';
                    case 'SetPoint':
                        return params.data.SetPoint != null && params.data.SetPoint != "null" ? params.data.SetPoint : '-NA-';
                    case 'SupplyTemp1':
                        return params.data.SupplyTemp1 != null && params.data.SupplyTemp1 != "null" ? params.data.SupplyTemp1 : '-NA-';
                    case 'SensorSupplyTemp1':
                        return params.data.SensorSupplyTemp1 != null && params.data.SensorSupplyTemp1 != "null" ? params.data.SensorSupplyTemp1 : '-NA-';
                    case 'SupplyTemp2':
                        return params.data.SupplyTemp2 != null && params.data.SupplyTemp2 != "null" ? params.data.SupplyTemp2 : '-NA-';
                    case 'ReturnTemp1':
                        return params.data.ReturnTemp1 != null && params.data.ReturnTemp1 != "null" ? params.data.ReturnTemp1 : '-NA-';
                    case 'SensorReturnTemp1':
                        return params.data.SensorReturnTemp1 != null && params.data.SensorReturnTemp1 != "null" ? params.data.SensorReturnTemp1 : '-NA-';
                    case 'ReturnTemp2':
                        return params.data.ReturnTemp2 != null && params.data.ReturnTemp2 != "null" ? params.data.ReturnTemp2 : '-NA-';
                    case 'AmbientTemp':
                        return params.data.AmbientTemp != null && params.data.AmbientTemp != "null" ? params.data.AmbientTemp : '-NA-';
                    case 'Humidity':
                        return params.data.Humidity != null && params.data.Humidity != "null" ? params.data.Humidity : '-NA-';
                    case 'EvaporatorTemp':
                        return params.data.EvaporatorTemp != null && params.data.EvaporatorTemp != "null" ? params.data.EvaporatorTemp : '-NA-';
                    case 'CompressorSuctionTemp':
                        return params.data.CompressorSuctionTemp != null && params.data.CompressorSuctionTemp != "null" ? params.data.CompressorSuctionTemp : '-NA-';

                    case 'CompressorDischargeTemp':
                        return params.data.CompressorDischargeTemp != null && params.data.CompressorDischargeTemp != "null" ? params.data.CompressorDischargeTemp : '-NA-';
                    case 'CompressorDischargeTemp2':
                        return params.data.CompressorDischargeTemp2 != null && params.data.CompressorDischargeTemp2 != "null" ? params.data.CompressorDischargeTemp2 : '-NA-';
                    case 'EvaporatorInletSensor':
                        return params.data.EvaporatorInletSensor != null && params.data.EvaporatorInletSensor != "null" ? params.data.EvaporatorInletSensor : '-NA-';
                    case 'EvaporatorOutletSensor':
                        return params.data.EvaporatorOutletSensor != null && params.data.EvaporatorOutletSensor != "null" ? params.data.EvaporatorOutletSensor : '-NA-';
                    case 'EconomizerInTemp':
                        return params.data.EconomizerInTemp != null && params.data.EconomizerInTemp != "null" ? params.data.EconomizerInTemp : '-NA-';
                    case 'EconomizerOutTemp':
                        return params.data.EconomizerOutTemp != null && params.data.EconomizerOutTemp != "null" ? params.data.EconomizerOutTemp : '-NA-';
                    case 'CondenserTemperature':
                        return params.data.CondenserTemperature != null && params.data.CondenserTemperature != "null" ? params.data.CondenserTemperature : '-NA-';
                    case 'USDA3Temp':
                        return params.data.USDA3Temp != null && params.data.USDA3Temp != "null" ? params.data.USDA3Temp : '-NA-';
                    case 'USDA2Temp':
                        return params.data.USDA2Temp != null && params.data.USDA2Temp != "null" ? params.data.USDA2Temp : '-NA-';
                    case 'USDA1Temp':
                        return params.data.USDA1Temp != null && params.data.USDA1Temp != "null" ? params.data.USDA1Temp : '-NA-';
                    case 'Cargo4Temp':
                        return params.data.Cargo4Temp != null && params.data.Cargo4Temp != "null" ? params.data.Cargo4Temp : '-NA-';
                    case 'DeviceTemp':
                        return params.data.DeviceTemp != null && params.data.DeviceTemp != "null" ? params.data.DeviceTemp : '-NA-';
                    case 'TemperatureUnit':
                        return params.data.TemperatureUnit != null && params.data.TemperatureUnit != "null" ? params.data.TemperatureUnit : '-NA-';
                    case 'CTTempLimit':
                        if (params.data.ReeferOEMTypeCd != null && params.data.ReeferOEMTypeCd.toUpperCase().trim() == "D") {
                            if (params.data.ACTMode != null && params.data.ACTMode.toString().toUpperCase().trim() == "TRUE")
                                return params.data.CTTempLimit != null && params.data.CTTempLimit != "" && params.data.CTTempLimit != "null" ? params.data.CTTempLimit : '-NA-';
                            else
                                return '-NA-';
                        }
                        else
                            return params.data.CTTempLimit != null && params.data.CTTempLimit != "" && params.data.CTTempLimit != "null" ? params.data.CTTempLimit : '-NA-';
                    case 'CTPostSetPoint':
                        if (params.data.ReeferOEMTypeCd != null && params.data.ReeferOEMTypeCd.toUpperCase().trim() == "D") {
                            if (params.data.ACTMode != null && params.data.ACTMode.toString().toUpperCase().trim() == "TRUE")
                                return params.data.CTPostSetPoint != null && params.data.CTPostSetPoint != "null" ? params.data.CTPostSetPoint : '-NA-';//RCNG-1818
                            else
                                return '-NA-';
                        }
                        else
                            return params.data.CTPostSetPoint != null && params.data.CTPostSetPoint != "null" ? params.data.CTPostSetPoint : '-NA-';//RCNG-1818
                }
            }
            else
                return '-NA-';
        }
        else
            return '-NA-';

        //if (param != null && param != undefined && param != "null") {
        //    return param;
        //}
        //else
        //    return '-NA-';
    }, 

    TemperatureValueFormatter: (params) => {        
        var tempRoundingValue = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureRoundPrecision;
       var dd = JSON.parse(sessionStorage.getItem('UserInfo'));
        var tempUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim();

        if (params != null && params != undefined) {
            if (params.value != null && params.value != undefined && params.value != '-NA-') {
                if (params.value.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                    return "OOR";
                else {
                    var tempVal = parseFloat(params.value);
                    if ((params.data.DeviceType != null && params.data.DeviceType != undefined && params.data.DeviceType.toString().toUpperCase().trim() == "ST9100") && params.colDef.field =="DeviceTemp") {                       
                        //if (tempVal == 0)
                            return '-NA-';
                    }
                    if (tempUnitCd.toUpperCase() == "F") {
                        tempVal = ((tempVal * 9) / 5) + 32;

                        var param = parseFloat(tempVal.toString());
                        /* return tempRoundingValue > 0 ? param.toFixed(parseInt(tempRoundingValue)) :
                            param.toFixed(1);*/
                        return tempRoundingValue > 0 ? param.toFixed(parseInt(tempRoundingValue)).toString() === "-0.0" ? parseFloat("0.0").toFixed(1) :
                            param.toFixed(parseInt(tempRoundingValue)) : param.toFixed(1);
                    }
                    else
                        /*    return tempRoundingValue > 0 ? tempVal.toFixed(parseInt(tempRoundingValue)):
                            param.toFixed(1);*/
                    return tempRoundingValue > 0 ? tempVal.toFixed(parseInt(tempRoundingValue)).toString() === "-0.0" ? parseFloat("0.0").toFixed(1) :
                        tempVal.toFixed(parseInt(tempRoundingValue)) : tempVal.toFixed(1);
                }
            }
            else
                return '-NA-';
        }
        else
            return '-NA-';

    },

    sensorDataValueFormatter: (params) => {
        if (params != null && params != undefined) {
            if (params.value != "-NA-" && params.value != null && params.value != undefined) {
                if (!isNaN(params.value)) { // WI 26545
                    if (params.value.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                        return "OOR";
                    else {
                        var param = parseFloat(params.value.toString());
                       // WI 26666 return param.toFixed(1).toString();
                        //return params.value.toFixed(1).toString();
                        return param.toFixed(1).toString() === "-0.0" ? parseFloat("0.0").toFixed(1) : param.toFixed(1).toString();
                    }
                }
                else
                    return params.value;                    
            }
            else
                return '-NA-';
        }
        else
            return '-NA-';
    },
    
    LineFrequencySorting: (params)=> {
         if (params != null && params != undefined) {
            if (params.data != null && params.data != undefined) {
                if (params.data.LineFrequency != null && params.data.LineFrequency != undefined && params.data.ReeferOEMTypeCd != null && params.data.ReeferOEMTypeCd !=undefined) {
					if(params.data.ReeferOEMTypeCd.toString().toUpperCase().trim() == "D" && (params.data.ControllerTypeCd == 27 || params.data.ControllerTypeCd == 28 || params.data.ControllerTypeCd == 32)) {
                        if(params.data.LineFrequencyQualifier != null && (params.data.LineFrequencyQualifier == 0 || params.data.LineFrequencyQualifier == 1)) {
                            if (params.data.LineFrequency.toString().trim() == "-999") 
                                return "Unknown";
                            return parseFloat(params.data.LineFrequency).toFixed(1).toString();
                        }
                        else if (params.data.LineFrequencyQualifier != null && params.data.LineFrequencyQualifier == 8)
                        {
                            //var value = params.value;
                            //if(value == 19)
                            return "High";
                        }
                        else if (params.data.LineFrequencyQualifier != null && params.data.LineFrequencyQualifier == 9)
                        {
                            //var value = params.value;
                            //if(value == 35)
                            return "Low";
                        } 
                        else 
                            return "Unknown";
                    }   
                    else
                    {
                        if (params.data.LineFrequency != null && params.data.LineFrequency != undefined) {
                            if (!isNaN(params.data.LineFrequency)) { // WI 26545
                                if (params.data.LineFrequency.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                                    return "OOR";
                                else {
                                    var param = parseFloat(params.data.LineFrequency.toString());
                                   // WI 26666 return param.toFixed(1).toString();
                                    //return params.value.toFixed(1).toString();
                                    return param.toFixed(1).toString() === "-0.0" ? parseFloat("0.0").toFixed(1) : param.toFixed(1).toString();
                                }
                            }
                            else
                                return params.data.LineFrequency;
                        }
                    }
                }
                else
                {
                    if (params.data.LineFrequency != null && params.data.LineFrequency != undefined) {
                        if (!isNaN(params.data.LineFrequency)) { // WI 26545
                            if (params.data.LineFrequency.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                                return "OOR";
                            else {
                                var param = parseFloat(params.data.LineFrequency.toString());
                               // WI 26666 return param.toFixed(1).toString();
                                //return params.value.toFixed(1).toString();
                                return param.toFixed(1).toString() === "-0.0" ? parseFloat("0.0").toFixed(1) : param.toFixed(1).toString();
                            }
                        }
                        else
                            return params.data.LineFrequency;
                    }
                } 
                    
            }           
          }
       return '-NA-';
    },

    lineFrequencyFormatter: (params) => {
        if (params != null && params != undefined) {
            if (params.value != "-NA-" && params.value != null && params.value != undefined) {
                if(params.data.ReeferOEMTypeCd != null && params.data.ReeferOEMTypeCd != undefined) {
                    if(params.data.ReeferOEMTypeCd.toString().toUpperCase().trim() == "D" && (params.data.ControllerTypeCd == 27 || params.data.ControllerTypeCd == 28 || params.data.ControllerTypeCd == 32)) {
                        if(params.data.LineFrequencyQualifier != null && (params.data.LineFrequencyQualifier == 0 || params.data.LineFrequencyQualifier == 1)) {
                            if (params.value.toString().trim() == "-999") 
                                return "Unknown";
                            return parseFloat(params.value).toFixed(1).toString();
                        }
                        else if (params.data.LineFrequencyQualifier != null && params.data.LineFrequencyQualifier == 8)
                        {
                            //var value = params.value;
                            //if(value == 19)
                            return "High";
                        }
                        else if (params.data.LineFrequencyQualifier != null && params.data.LineFrequencyQualifier == 9)
                        {
                            //var value = params.value;
                            //if(value == 35)
                            return "Low";
                        } 
                        else 
                            return "Unknown";
                    }   
                    else
                    {
                        if (!isNaN(params.value)) { // WI 26545
                            if (params.value.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                                return "OOR";
                            else {
                                var param = parseFloat(params.value.toString());
                               // WI 26666 return param.toFixed(1).toString();
                                //return params.value.toFixed(1).toString();
                                return param.toFixed(1).toString() === "-0.0" ? parseFloat("0.0").toFixed(1) : param.toFixed(1).toString();
                            }
                        }
                        else
                            return params.value;
                    }
                }
                else
                {
                    if (!isNaN(params.value)) { // WI 26545
                        if (params.value.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                            return "OOR";
                        else {
                            var param = parseFloat(params.value.toString());
                           // WI 26666 return param.toFixed(1).toString();
                            //return params.value.toFixed(1).toString();
                            return param.toFixed(1).toString() === "-0.0" ? parseFloat("0.0").toFixed(1) : param.toFixed(1).toString();
                        }
                    }
                    else
                        return params.value;
                }
            }
            //else
            return '-NA-';
        }
        //else
        return '-NA-';
    },

    sensorDataValueFormatterTwoDecimal: (params) => {
        if (params != null && params != undefined) {
            if (params.value != "-NA-" && params.value != null && params.value != undefined) {
                if (!isNaN(params.value)) { //WI 26802
                    if (params.value.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                        return "OOR";
                    else {

                        var param = parseFloat(params.value.toString());
                        // WI 26666 return param.toFixed(2).toString();
                        //return params.value.toFixed(2).toString();
                        return param.toFixed(1).toString() === "-0.0" ? parseFloat("0.0").toFixed(1) : param.toFixed(1).toString();
                    }
                }
                else
                    return params.value;   
            }
            else
                return '-NA-';
        }
        else
            return '-NA-';
    },

    sensorDataSortingFieldName: (params, FieldName) => {
        if (params != null && params != undefined) {
            if (params.data != null && params.data != undefined) {
                switch (FieldName) {
                    case 'CO2Setpoint':
                        return params.data.CO2Setpoint != null && params.data.CO2Setpoint != "null" ? params.data.CO2Setpoint : '-NA-';
                    case 'HumiditySetpoint':
                        return params.data.HumiditySetpoint != null && params.data.HumiditySetpoint != "null" ? params.data.HumiditySetpoint : '-NA-';
                    case 'CO2Reading':
                        return params.data.CO2Reading != null && params.data.CO2Reading != "null" ? params.data.CO2Reading : '-NA-';
                    case 'O2Setpoint':
                        return params.data.O2Setpoint != null && params.data.O2Setpoint != "null" ? params.data.O2Setpoint : '-NA-';
                    case 'O2Reading':
                        return params.data.O2Reading != null && params.data.O2Reading != "null" ? params.data.O2Reading : '-NA-';
                    case 'CompositeSuctionPressure':
                        return params.data.CompositeSuctionPressure != null && params.data.CompositeSuctionPressure != "null" ? params.data.CompositeSuctionPressure : '-NA-';
                    case 'DischargePressure':
                        return params.data.DischargePressure != null && params.data.DischargePressure != "null" ? params.data.DischargePressure : '-NA-';
                    case 'CondenserPressure':
                        return params.data.CondenserPressure != null && params.data.CondenserPressure != "null" ? params.data.CondenserPressure : '-NA-';
                    case 'CondenserFanOutPut':
                        return params.data.CondenserFanOutPut != null && params.data.CondenserFanOutPut != "null" ? params.data.CondenserFanOutPut : '-NA-';
                    case 'LowSpeedEvaporatorFanOutPut':
                        return params.data.LowSpeedEvaporatorFanOutPut != null && params.data.LowSpeedEvaporatorFanOutPut != "null" ? params.data.LowSpeedEvaporatorFanOutPut : '-NA-';
                    case 'HighSpeedEvaporatorFanOutPut':
                        return params.data.HighSpeedEvaporatorFanOutPut != null && params.data.HighSpeedEvaporatorFanOutPut != "null" ? params.data.HighSpeedEvaporatorFanOutPut : '-NA-';
                    case 'HeaterOnTime':
                        return params.data.HeaterOnTime != null && params.data.HeaterOnTime != "null" ? params.data.HeaterOnTime : '-NA-';
                    case 'HotGasValveOpening':
                        return params.data.HotGasValveOpening != null && params.data.HotGasValveOpening != "null" ? params.data.HotGasValveOpening : '-NA-';
                    case 'EconomizerValveOpening':
                        return params.data.EconomizerValveOpening != null && params.data.EconomizerValveOpening != "null" ? params.data.EconomizerValveOpening : '-NA-';
                    case 'CompressorFrequency':
                        return params.data.CompressorFrequency != null && params.data.CompressorFrequency != "null" ? params.data.CompressorFrequency : '-NA-';
                    case 'VentPositionSensorCMH':
                        return params.data.VentPositionSensorCMH != null && params.data.VentPositionSensorCMH != "null" ? params.data.VentPositionSensorCMH : '-NA-';
                    case 'TotalCurrentDraw':
                        return params.data.TotalCurrentDraw != null && params.data.TotalCurrentDraw != "null" ? params.data.TotalCurrentDraw : '-NA-';
                    case 'LineVoltage1':
                        return params.data.LineVoltage1 != null && params.data.LineVoltage1 != "null" ? params.data.LineVoltage1 : '-NA-';
                    case 'LineVoltage2':
                        return params.data.LineVoltage2 != null && params.data.LineVoltage2 != "null" ? params.data.LineVoltage2 : '-NA-';
                    case 'LineVoltage3':
                        return params.data.LineVoltage3 != null && params.data.LineVoltage3 != "null" ? params.data.LineVoltage3 : '-NA-';
                    case 'CompressorCurrent':
                        return params.data.CompressorCurrent != null && params.data.CompressorCurrent != "null" ? params.data.CompressorCurrent : '-NA-';
                    case 'VFD':
                        return params.data.VFD != null && params.data.VFD != "null" ? params.data.VFD : '-NA-';
                    case 'LineFrequency':
                        return params.data.LineFrequency != null && params.data.LineFrequency != "null" ? params.data.LineFrequency : '-NA-';
                    case 'ReeferACPowerLevel':
                        return params.data.ReeferACPowerLevel != null && params.data.ReeferACPowerLevel != "null" ? params.data.ReeferACPowerLevel : '-NA-';
                   /* RCNG-169 case 'TripWiseExpiration':
                        return params.data.TripWiseExpiration != null && params.data.TripWiseExpiration != "null" ? params.data.TripWiseExpiration : '-NA-';*/

                }
            }
            else
                return '-NA-';
        }
        else
            return '-NA-';
        //if (param != null && param != undefined && param != "null") {
        //    return param;
        //}
        //else
        //    return '-NA-';
    },

    HumiditySettingFormatter: (params) => {
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.Humidity != null && params.data.Humidity !== '' && params.data.Humidity != '-NA-') {
                
                if (params.data.Humidity.toString().trim() == "0")// || params.data.HumiditySetpointStatus == "O")
                    return "Off";
                else if (params.data.Humidity.toString().trim() == "-999")
                    return "OOR";
                else if (params.data.Humidity > 0 && params.data.Humidity <= 100)//RCNG-2963
                    return params.data.Humidity.toFixed(1).toString();
                else if (params.data.Humidity > 100 && params.data.HumiditySetpointStatus == "O")
                    return "Off";
                else
                    return "-NA-";                
            }
            return '-NA-';
        }
        return '-NA-';
    },

    HumiditySetpointFormatter: (params) => {
        if (params != null && params != undefined) {
            if(params.data.HumiditySetpointStatus != null && params.data.HumiditySetpointStatus != '') {
                if(params.data.HumiditySetpointStatus.toUpperCase().trim() == "OFF" || params.data.HumiditySetpointStatus == "O")//RCNG-4689
                    return "Off";
            }
            if (params.value != "-NA-" && params.value != null && params.value != undefined) {
                if (params.value.toString().trim() == "0")
                    return "Off";
                //else if (params.value.toString().trim() == "-999") 
                else if (params.value > 0 && params.value <= 100)//RCNG-2963
                    return params.value.toFixed(1).toString();
                else
                    return "OOR";
                //else if (params.value > 100 || params.value.toString().trim() == "-999") {
                //    return "OOR";
                //}
            }
            else
                return '-NA-';
        }
        else
            return '-NA-';
    },

    sensorDataPCondFormatter: (params) => {
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.ReeferOEMTypeCd != null && params.data.ReeferOEMTypeCd != '') {
                if (params.data.ReeferOEMTypeCd.trim() == 'C')
                    return '-NA-';
                else {
                    if (params.data.CondenserPressure != null && params.data.CondenserPressure != '-NA-') {
                        if (params.data.CondenserPressure.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                            return "OOR";
                        else
                            return params.data.CondenserPressure.toString();
                    }
                    else
                        return '-NA-';
                }
            }
            return '-NA-';
        }
        return '-NA-';
    },

    sensorDataOpenExpFormatter: (params) => {
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.ReeferOEMTypeCd != null && params.data.ReeferOEMTypeCd != '') {
                if (params.data.ReeferOEMTypeCd.trim() == 'C')
                    return '-NA-';
                else {
                    if (params.data.EvaporatorExpansionValveOpening != null && params.data.EvaporatorExpansionValveOpening != '-NA-') {
                        if (params.data.EvaporatorExpansionValveOpening.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                            return "OOR";
                        else
                            return params.data.EvaporatorExpansionValveOpening.toString();
                    }
                    else
                        return '-NA-';
                }
            }
            return '-NA-';
        }
        return '-NA-';
    },

    sensorDataOpenSucFormatter: (params) => {
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.ReeferOEMTypeCd != null && params.data.ReeferOEMTypeCd != '') {
                if (params.data.ReeferOEMTypeCd.trim() == 'C') {
                    return '-NA-';
                }
                else {
                    if (params.data.SuctionModulationValveOpening != null && params.data.SuctionModulationValveOpening != '' && params.data.SuctionModulationValveOpening != '-NA-') {
                        if (params.data.SuctionModulationValveOpening.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                            return "OOR";
                        else
                            return params.data.SuctionModulationValveOpening.toString();
                    }
                    else
                        return '-NA-';
                }
            }
            return '-NA-';
        }
        return '-NA-';
    },

    ControlledAtmosphereMode: (params) => {
        if (params.data != null && params.data != '-NA-' && params.data != undefined && params.data != '') {
            if (params.data.ControlledAtmosphereMode != null && params.data.ControlledAtmosphereMode != undefined && params.data.ControlledAtmosphereMode != '') {
                if (params.data.ReeferOEMTypeCd != null && params.data.ReeferOEMTypeCd != '') {
                    if (params.data.ReeferOEMTypeCd.trim() == 'S') {

                        if (params.data.ControlledAtmosphereMode.toString().toUpperCase().trim() == "ON")
                            return "CA On";
                        else if (params.data.ControlledAtmosphereMode.toString().toUpperCase().trim() == "OFF")
                            return "Off";
                        else if (params.data.ControlledAtmosphereMode.toString().toUpperCase().trim() == "AV")
                            return "AV On";
                        else if (params.data.ControlledAtmosphereMode.toString().toUpperCase().trim() == "AVPLUS")
                            return "AV+ On";
                        else
                            return params.data.ControlledAtmosphereMode.toString();
                    }
                    else if (params.data.ControlledAtmosphereMode.toString().toUpperCase().trim() == "UNITOFF")
                        return "Unit Off";
                    else
                        return params.data.ControlledAtmosphereMode.toString();
                }
                else
                    return '-NA-';
            }
            else
                return '-NA-';
        }
        else
            return '-NA-';

    },

    ThreePhaseCurrentSortingFieldName: (params, FieldName) => {
        if (params != null && params != undefined) {
            if (params.data != null && params.data != undefined) {

                if (FieldName === "ThreePhaseCurrent") {
                    return params.data.ThreePhaseCurrent;
                }
                else
                    return "-NA-";
            }
            else
                return '-NA-';
        }
        else
            return '-NA-';

    },

    Current3PhaseFormatter: (params) => {
        var currentValue1 = "";
        var currentValue2 = "";
        var currentValue3 = "";
        if (params.value != null && params.value != "-NA-") {
            var phases = params.value.split(",");
            if (phases[0].toString().trim() == "-999")
                currentValue1 = "OOR";
            else {
                var param = parseFloat(phases[0].toString());
                currentValue1 = param.toFixed(0).toString().trim() == "NaN" ? "" : param.toFixed(1).toString().trim();//WI-26512-in else toFixed number was wrong
                //currentValue1 = phases[0].toString().trim();
            }
                
            if (phases[1].toString().trim() == "-999")
                currentValue2 = "OOR";
            else {
                var param = parseFloat(phases[1].toString());
                currentValue2 = param.toFixed(1).toString().trim() == "NaN" ? "" : param.toFixed(1).toString().trim();
                //currentValue2 = phases[1].toString().trim();
            }
                
            if (phases[2].toString().trim() == "-999")
                currentValue3 = "OOR";
            else {
                var param = parseFloat(phases[2].toString());
                currentValue3 = param.toFixed(2).toString().trim() == "NaN" ? "" : param.toFixed(1).toString().trim();//WI-26512-in else toFixed number was wrong
                //currentValue3 = phases[2].toString().trim();
            }
                

            return currentValue1 + ", " + currentValue2 + ", " + currentValue3;
        }
        else
            return "-NA-";
    },

    AlarmDescriptionFormatter: (params, alarmsList) => {
        var element = document.createElement("span");
        if (params.data != null && params.data != undefined) {
            if (params.data.AlarmsList != null && params.data.AlarmsList != undefined && params.data.AlarmsList != '') {
                var lstAlarms = params.data.AlarmsList.split(',');
                $.each(lstAlarms, function (index, item) {
                    if (item != "" && item != null) {
                        if (parseInt(index.toString()) > 0) {
                            var spanElement = document.createElement("span");
                            spanElement.innerText = ", ";
                            element.appendChild(spanElement);
                        }

                        if (alarmsList != null && alarmsList != undefined && alarmsList.length > 0) {
                            if (params.node.data.DeviceType != null && params.node.data.DeviceType != undefined && params.node.data.DeviceType.toString().trim() == "ST9100") {
                                var alarmDescription = alarmsList.filter(e =>
                                    e.AlarmAlias === item && e.AlarmSeriesTypeCD.toString().toUpperCase().trim() === "K");
                                var anchorElement = document.createElement("a");
                                anchorElement.title = alarmDescription.length > 0 ? alarmDescription[0].Description.toString() : "";
                                anchorElement.text = item;
                                element.appendChild(anchorElement);
                            }
                            else {
                            var alarmDescription = alarmsList.filter(e =>
                                e.AlarmAlias === item);
                            var anchorElement = document.createElement("a");
                            anchorElement.title = alarmDescription.length > 0 ? alarmDescription[0].Description.toString() : "";
                            anchorElement.text = item;
                            element.appendChild(anchorElement);
                            }
                        }
                    }
                });

                return element;
            }

            else return "-NA-";
        }
    },

    AlarmDescriptionSorting: (params, alarmsList) => {
        var element = document.createElement("span");
        if (params.data != null && params.data != undefined) {
            if (params.data.AlarmsList != null && params.data.AlarmsList != undefined && params.data.AlarmsList != '' && params.data.AlarmsList != "null") {
                return params.data.AlarmsList;
            }

            else return "-NA-";
        }
    },  
    
    CCAlarmAliasDescriptionSorting: (params, alarmsList) => {
        //var element = document.createElement("span");
        if (params.data != null && params.data != undefined) {
            if (params.data.CCAlarms != null && params.data.CCAlarms != undefined && params.data.CCAlarms != '' && params.data.CCAlarms != "null") {
                //if (params.data.CCAlarms.toString().endsWith(","))  //Added if condition code for RCNG-839
                var lstalarmcd: any = params.data.CCAlarms.split(',');
                var alarmalias: any = "";
                if (lstalarmcd.length > 0) {
                    $.each(lstalarmcd, function (index, almCd) {
                        var alarm = alarmsList.filter(e => e.AlarmCd === almCd);
                        //if (alarm[0].AlarmAlias != "" && alarm[0].AlarmAlias != null) {
                        if (alarm.length > 0) {//RCNG-2051
                            alarmalias += alarm[0].AlarmAlias + ",";
                        }
                    });

                    return alarmalias.slice(0, -1);
                }

                var alarmcd = params.data.CCAlarms;
                var alarm = alarmsList.filter(e => e.AlarmCd === alarmcd);
                //if (alarm[0].AlarmAlias != "" && alarm[0].AlarmAlias != null) {
                if (alarm.length > 0) {//RCNG-2051
                    return alarm[0].AlarmAlias;
                }
            }

            else return "-NA-";
        }
    },

    CCAlarmDescriptionSorting: (params, alarmsList) => {
        //var element = document.createElement("span");
        if (params.data != null && params.data != undefined) {
            if (params.data.CCAlarms != null && params.data.CCAlarms != undefined && params.data.CCAlarms != '' && params.data.CCAlarms != "null") {
                if (params.data.CCAlarms.toString().endsWith(","))  //Added if condition code for RCNG-839
                    return params.data.CCAlarms.slice(0, -1);
                else
                return params.data.CCAlarms;
            }

            else return "-NA-";
        }
    },  

    OperatingModeFormatter: (params) => {
        var valueString = '-NA-';
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.RunningMode != null && params.data.RunningMode != undefined && params.data.RunningMode != '') {
                valueString = params.data.RunningMode.replace('/^\s+/g', '');

                if (valueString.startsWith(",")) {
                    valueString = valueString.substring(1, valueString.length);
                }

                if (valueString.endsWith(",")) {
                    valueString = valueString.substring(0, valueString.length - 1);
                }

                return valueString;
            }
        }
        return '-NA-';

    },
    //Start RCNG-1818
    CTDurationFormatter: (params) => {
        if (params.value != null && params.value != 0) {
            if (params.value.toString().trim() == "-999")
                return "OOR";
            else
                return params.value;
        }
        else
            return '-NA-';
    },
    CTRemainingTimeFormatter: (params) => {
        if (params.value != null && params.value != 0) {
            if (params.value.toString().trim() == "-999")
                return "OOR";
            else
                return params.value;
        }
        else
            return '-NA-';
    },
    CTTimeFormatter: (params) => {
        if (params.value != null && params.value != 0) {
            if (params.value.toString().trim() == "-999")
                return "OOR";
            else
                return params.value;
        }
        else
            return '-NA-';
    },
    AirPumpRunHoursFormatter: (params) => {
        if (params.value != null) {
            if (params.value.toString().trim() == "-999")
                return "OOR";
            else
                return params.value;
        }
        else
            return '-NA-';
    },
    CARunHoursFormatter: (params) => {
        if (params.value != null) {
            if (params.value.toString().trim() == "-999")
                return "OOR";
            else
                return params.value;
        }
        else
            return '-NA-';
    },

    PowerMeterFormatter: (params) => {
        if (params.value != null) {
            if (params.value.toString().trim() == "-999")
                return "OOR";
            else
                return params.value;
        }
        else
            return '-NA-';
    },
    CASWVerFormatter: (params) => {
        if (params.value != null && params.value != 0) {
            if (params.value.toString().trim() == "-999")
                return "OOR";
            else
                return params.value;
        }
        else
            return '-NA-';
    },
    CompressorRunHoursFormatter: (params) => {
        if (params.value != null) {
            if (params.value.toString().trim() == "-999")
                return "OOR";
            else
                return params.value;
        }
        else
            return '-NA-';
    },
    //end RCNG-1818
    TripWiseExpirationFormatter: (params) => {
        if (params.value != null && params.value != "0") {
            if (params.value.toString().trim() == "-999")
                return "OOR";
            else
                return params.value;
        }
        else
            return '-NA-';
    },
    DimiRemainTermFormatter: (params) => {
        if (params.value != null && params.value != undefined) {
            if (params.value.toString().trim() == "-999")
                return "OOR";
            else
                return params.value;
        }
        else
            return '-NA-';
    },

    preTripFormatter: (params) => {
        if (params.value != null && params.value != undefined) {
            if (params.value.toString().trim() != "-NA-" && params.value.toString().trim() != "") {
                var element = document.createElement("span");
                element.className = "reefer-alert-PTI";
                var imageElement = document.createElement("img");

                if (params.value == 'Passed') {
                    return '<span title="Passed" class="fas fa-check GridIcons green-text-color"></span>';
                }
                else if (params.value == 'Failed') {
                    return '<span title="Failed" class="fas fa-exclamation GridIcons color-red"> </span>';
                }
                else if (params.value == 'Aborted') {
                    return '<span title="Expired" class="fas fa-times GridIcons orangetext "></span>';
                }
                else if (params.value == 'Running') {
                    return '<span title = "Running" class="fas fa-history GridIcons black-text-color" > </span>';
                }
                else if (params.value == 'Skipped') {
                    return '<span title="Skipped" class="fas fa-step-forward GridIcons magenta-color-text "></span>';
                }
                else if (params.value == 'Unknown') {
                    return '<span title = "Unknown" class="fas fa-question GridIconsQuestion black-text-color" > </span>';
                }
            }
        }
        return '-NA-';
    },

    PTResultSorting: (params) => {
        if (params != null && params != undefined) {
            if (params.data != null && params.data != undefined) {
                if (params.data.PTResult != null && params.data.PTResult != undefined) {
                    if (params.data.PTResult.toString().trim() != "-NA-" && params.data.PTResult.toString().trim() != "") {

                        switch (params.data.PTResult.toString().trim()) {
                            case 'Passed':
                            case 'OK':
                                return "Passed";
                            case 'Failed':
                            case 'NG':
                                return "Failed";
                            case 'Aborted':
                                return "Aborted";
                            case 'Running':
                                return "Running";
                            case 'Skipped':
                                return "Skipped";
                            case 'Unknown':
                                return "Unknown";
                        }
                    }
                    else
                        return "-NA-";
                }
                else
                    return "-NA-";
            }
            else
                return "-NA-";
        }
        else
            return "-NA-";

    },

    TripWiseStatusFormatter: (params, TripWiseStatusList) => {
        var TripWiseStatusDescription = '-NA-';
        var TripWiseStatusID = null;
        if (params != null && params != undefined && params.data != null && params.data != null && params.data != undefined) {
            TripWiseStatusID = params.data.TripWiseStatusID;

            if (TripWiseStatusID != null) {
                if (TripWiseStatusList != null && TripWiseStatusList != undefined && TripWiseStatusList.length > 0) {
                    var TripWiseStatusId = lodashfilter(TripWiseStatusList, function (item) {
                        return item.TripWiseStatusID === TripWiseStatusID;
                    });
                    if (TripWiseStatusId != null && TripWiseStatusId.length > 0) {
                        TripWiseStatusDescription = TripWiseStatusId[0].Description;

                        if (TripWiseStatusDescription == 'Off') {
                            return '<span title="Off" class="fas fa-square GridIcons greytext"></span>';
                        }
                        else if (TripWiseStatusDescription == 'Expired') {
                            return '<span title = "Expired" class="fas fa-times GridIcons orangetext"> </span>';
                        }
                        else if (TripWiseStatusDescription == 'Check') {
                            return '<span title = "Check" class="fas fa-exclamation GridIcons color-red"></span>';
                        }
                        else if (TripWiseStatusDescription == 'Passed') {
                            return '<span title = "Passed" class="fas fa-check GridIcons green-text-color" > </span>';
                        }
                        else if (TripWiseStatusDescription == 'Running') {
                            return '<span title = "Running" class="fas fa-history GridIcons black-text-color"></span>';
                        }
                        else if (TripWiseStatusDescription == 'Unknown') {
                            return '<span title = "Unknown" class="fas fa-question GridIconsQuestion black-text-color" ></span>';
                        }
                    }
                }                
            }
        }
        return TripWiseStatusDescription;
    },
    TripWiseStatusSorting: (params, TripWiseStatusList) => {
    var TripWiseStatusDescription = '-NA-';
    var TripWiseStatusID = null;
    if (params != null && params != undefined && params.data != null && params.data != null && params.data != undefined && params.data.ReeferOEMTypeCd != null && params.data.ReeferOEMTypeCd.toUpperCase().trim() != "D") {
        TripWiseStatusID = params.data.TripWiseStatusID;
 
        if (TripWiseStatusID != null) {
            if (TripWiseStatusList != null && TripWiseStatusList != undefined && TripWiseStatusList.length > 0) {
                var TripWiseStatusId = lodashfilter(TripWiseStatusList, function (item) {
                    return item.TripWiseStatusID === TripWiseStatusID;
                });
                if (TripWiseStatusId != null && TripWiseStatusId.length > 0) {
                    TripWiseStatusDescription = TripWiseStatusId[0].Description;
                }
            }                
        }
    }
    else {
        if (params != null && params != undefined && params.data != null && params.data != null && params.data != undefined){
        if (params.data.DimiMode != null && params.data.DimiMode.toUpperCase().trim() == "OFF") {
            TripWiseStatusDescription = 'Off';
        }
        else if (params.data.DimiMode != null && params.data.DimiMode.toUpperCase().trim() == "ON") {
 
            if (params.data.DimiResultActuator == "Passed" && params.data.DimiResultAlarm == "Passed" &&
                params.data.DimiResultOOR == "Passed" && params.data.DimiResultTerm == "Passed"
                && params.data.DimiResultValidity == "Passed") {
                TripWiseStatusDescription = "Passed";
            }
            else if ((params.data.DimiResultValidity == "Failed") && (
                (params.data.DimiResultActuator == "Passed" || params.data.DimiResultActuator == "Unknown") &&
                (params.data.DimiResultAlarm == "Passed" || params.data.DimiResultAlarm == "Unknown") &&
                (params.data.DimiResultOOR == "Passed" || params.data.DimiResultOOR == "Unknown") &&
                (params.data.DimiResultTerm == "Passed" || params.data.DimiResultTerm == "Unknown"))) {
                TripWiseStatusDescription = "Expired";
            }
            else if ((params.data.DimiResultActuator == "Unknown" || params.data.DimiResultAlarm == "Unknown"
                || params.data.DimiResultOOR == "Unknown" || params.data.DimiResultTerm == "Unknown"
                || params.data.DimiResultValidity == "Unknown") &&
                (params.data.DimiResultActuator != "Failed" && params.data.DimiResultAlarm != "Failed" &&
                    params.data.DimiResultOOR != "Failed" && params.data.DimiResultTerm != "Failed" &&
                params.data.DimiResultValidity != "Failed")) {
                TripWiseStatusDescription = "Unknown";
            }
            else if (params.data.DimiResultActuator == "Failed" || params.data.DimiResultAlarm == "Failed"
                || params.data.DimiResultOOR == "Failed" || params.data.DimiResultTerm == "Failed") {
                TripWiseStatusDescription = "Check";
            }
        }
    }
    }
    return TripWiseStatusDescription;
},
    doorQuickFilterFormatter: (param) => {
        if (param != null && param != undefined) {
            if (param.value == 1)
                return "Open";
            else if (param.value == 2)
                return "Closed";
            else if (param.value == 3)
                return "Sensor Error" //RCNG-1106
            else if (param.value == 4)
                return "No Sensor"
            else if (param.value == 5)
                return "-NA-"
            else
                return "-NA-";
        }
    },
    doorFormatterFilter: (params) => {
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.EnableDoorSensor != null && params.data.EnableDoorSensor.toString().toUpperCase().trim() == "TRUE") {
                if (params.data.DoorOpen != null) {
                    if (params.data.DoorOpen.toString().toUpperCase().trim() == "TRUE")
                        return "Open";
                    else
                        return "Closed";
                }
                else
                    if (params.data.RCDStateReportedHistoryID != null && params.data.RCDStateReportedHistoryID != undefined && params.data.RCDStateReportedHistoryID != '')
                        return "Sensor Error"; //RCNG-1106, RCNG-1141
                    else
                        return '-NA-';
            }
            else
                return "No Sensor";
        }
        else
            return '-NA-';
    },
    DevicedoorFormatterFilter: (params) => {
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.AssetType != null && params.data.AssetType.toString().toUpperCase().trim() == "R") {
                if (params.data.EnableDoorSensor != null && params.data.EnableDoorSensor.toString().toUpperCase().trim() == "TRUE") {
                    if (params.data.DoorOpen != null) {
                        //if (params.data.DoorOpen.toString().toUpperCase().trim() == "TRUE")
                        //    return "Open";
                        //else
                        //    return "Closed";
                        switch (params.data.DoorOpen.toString().toUpperCase().trim()) {
                            case "OPN":
                                return "Open";
                            case "CLS":
                                return "Closed";
                            case "DIS":
                                return "Sensor Error"
                            case "UNP":
                                return "No Sensor";
                            case "UNK":
                                return "-NA-";
                        }
                    }
                    else
                        if (params.data.RCDStateReportedHistoryID != null && params.data.RCDStateReportedHistoryID != undefined && params.data.RCDStateReportedHistoryID != '')
                            return "Sensor Error"; //RCNG-1106, RCNG-1141
                        else
                            return '-NA-';
                }
                else
                    return "No Sensor";
            }
            else if (params.data.AssetType != null && params.data.AssetType.toString().toUpperCase().trim() == "D") {
                if (params.data.HasDoorSensor != null && params.data.HasDoorSensor.toString().toUpperCase().trim() == "TRUE") {
                    if (params.data.DoorOpen != null) {
                        //if (params.data.DoorOpen.toString().toUpperCase().trim() == "TRUE")
                        //    return "Open";
                        //else
                        //    return "Closed";
                        switch (params.data.DoorOpen.toString().toUpperCase().trim()) {
                            case "OPN":
                                return "Open";
                            case "CLS":
                                return "Closed";
                            case "DIS":
                                return "Sensor Error"
                            case "UNP":
                                return "No Sensor";
                            case "UNK":
                                return "-NA-";
                        }
                    }
                    else
                        return "-NA-";
                }
                else
                    return "No Sensor";
            }
            else
                return '-NA-';
        }
        else
            return '-NA-';
    },
    DoorFormatterSorting: (params) => {
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.EnableDoorSensor != null && params.data.EnableDoorSensor.toString().toUpperCase().trim() == "TRUE") {
                if (params.data.DoorOpen != null) {
                    if (params.data.DoorOpen.toString().toUpperCase().trim() == "TRUE")
                        return "1";
                    else
                        return "2";
                }
                else
                    if (params.data.RCDStateReportedHistoryID != null && params.data.RCDStateReportedHistoryID != undefined && params.data.RCDStateReportedHistoryID != '')
                        return "3"; //RCNG-1106,RCNG-1141
                    else
                        return '5';
            }
            else
                return "4";
        }
        else
            return '5';
    },
    DeviceDoorFormatterSorting: (params) => {
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.AssetType != null && params.data.AssetType.toString().toUpperCase().trim() == "R") {
                if (params.data.EnableDoorSensor != null && params.data.EnableDoorSensor.toString().toUpperCase().trim() == "TRUE") {
                    if (params.data.DoorOpen != null) {
                        //if (params.data.DoorOpen.toString().toUpperCase().trim() == "TRUE")
                        //    return "1";
                        //else
                        //    return "2";
                        switch (params.data.DoorOpen.toString().toUpperCase().trim()) {
                            case "OPN": return "1";
                            case "CLS": return "2";
                        }
                    }
                    else
                        if (params.data.RCDStateReportedHistoryID != null && params.data.RCDStateReportedHistoryID != undefined && params.data.RCDStateReportedHistoryID != '')
                            return "3"; //RCNG-1106, RCNG-1141
                        else
                            return "6";
                }
                else
                    return "4";
            }
            else if (params.data.AssetType != null && params.data.AssetType.toString().toUpperCase().trim() == "D") {
                if (params.data.HasDoorSensor != null && params.data.HasDoorSensor.toString().toUpperCase().trim() == "TRUE") {
                    if (params.data.DoorOpen != null) {
                        //if (params.data.DoorOpen.toString().toUpperCase().trim() == "TRUE")
                        //    return "1";
                        //else
                        //    return "2";
                        switch (params.data.DoorOpen.toString().toUpperCase().trim()) {
                            case "OPN":
                                return "1";
                            case "CLS":
                                return "2";
                            case "DIS":
                                return "3"
                            case "UNP":
                                return "4";
                            case "UNK":
                                return "5";
                        }
                    }
                    else
                        return "5";
                }
                else
                    return "4";
            }
            else
                return "6";
        }
        else
            return "6";
    },
    doorFormatter: (params) => {
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.EnableDoorSensor != null && params.data.EnableDoorSensor.toString().toUpperCase().trim() == "TRUE") {
                if (params.data.DoorOpen != null) {
                    if (params.data.DoorOpen.toString().toUpperCase().trim() == "TRUE")
                        return "Open";
                    else
                        return "Closed";
                }
                else {
                    if (params.data.RCDStateReportedHistoryID != null && params.data.RCDStateReportedHistoryID != undefined && params.data.RCDStateReportedHistoryID != '')
                        return "Sensor Error"; //RCNG-1106,RCNG-1141
                    else
                        return '-NA-';
                }
            }
            else
                return "No Sensor";
        }
        else
            return '-NA-';
    },
    DevicedoorFormatter: (params) => {
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.AssetType != null && params.data.AssetType.toString().toUpperCase().trim() == "R") {
                if (params.data.EnableDoorSensor != null && params.data.EnableDoorSensor.toString().toUpperCase().trim() == "TRUE") {
                    if (params.data.DoorOpen != null) {
                        //if (params.data.DoorOpen.toString().toUpperCase().trim() == "TRUE")
                        //    return "Open";
                        //else
                        //    return "Closed";
                        switch (params.data.DoorOpen.toString().toUpperCase().trim()) {
                            case "OPN":
                                return "Open";
                            case "CLS":
                                return "Closed";
                            case "DIS":
                                return "Sensor Error"
                            case "UNP":
                                return "No Sensor";
                            case "UNK":
                                return "-NA-";
                        }
                    }
                    else
                        if (params.data.RCDStateReportedHistoryID != null && params.data.RCDStateReportedHistoryID != undefined && params.data.RCDStateReportedHistoryID != '')
                            return "Sensor Error"; //RCNG-1106, RCNG-1141
                        else
                            return '-NA-';
                }
                else
                    return "No Sensor";
            }
            else if (params.data.AssetType != null && params.data.AssetType.toString().toUpperCase().trim() == "D") {
                if (params.data.HasDoorSensor != null && params.data.HasDoorSensor.toString().toUpperCase().trim() == "TRUE") {
                    if (params.data.DoorOpen != null) {
                        //if (params.data.DoorOpen.toString().toUpperCase().trim() == "TRUE")
                        //    return "Open";
                        //else
                        //    return "Closed";
                        switch (params.data.DoorOpen.toString().toUpperCase().trim()) {
                            case "OPN":
                                return "Open";
                            case "CLS":
                                return "Closed";
                            case "DIS":
                                return "Sensor Error"
                            case "UNP":
                                return "No Sensor";
                            case "UNK":
                                return "-NA-";
                        }
                    }
                    else
                        return "-NA-";
                }
                else
                    return "No Sensor";
            }
            else
                return '-NA-';
        }
        else
            return '-NA-';
    },
    //RCNG-1106,RCNG-1141
    DoorFormatterGrouping: (param) => {
        if (param != null && param != undefined) {
            if (param == 1)
                return "Open";
            else if (param == 2)
                return "Closed";
            else if (param == 3)
                return "Sensor Error"
            else if (param == 4)
                return "No Sensor"
            else if (param == 5)
                return "*No Door"
        }
    },
    DoorFormatterExcel: (param) => {
        if (param != null && param != undefined) {
            if (param == 1)
                return "Open";
            else if (param == 2)
                return "Closed";
            else if (param == 3)
                return "Sensor Error"
            else if (param == 4)
                return "No Sensor"
            else if (param == 5)
                return "-NA-"
        }
    },

    everFreshFormatter: (params) => {
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.EverFRESH == true) {
                return 'On';
            }
            else if (params.data.EverFRESH == false)
                return 'Off';
            else
                return '-NA-';
        }
        return '-NA-';
    },
    everFreshQuickFilterFormatter: (param) => {
        if (param != null && param != undefined) {
            if (param.value == 1)
                return "On";
            else if (param.value == 2)
                return "Off";
            else
                return "-NA-";
        }
    },
    everFreshFormatterSorting: (params) => {
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.EverFRESH != null) {
                if (params.data.EverFRESH == true)
                    return '1';
                else
                    return '2';
            }
            else
                return '3';
        }
        else
            return '3';
    },
    everFreshFormatterFilter: (params) => {
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.EverFRESH != null) {
                if (params.data.EverFRESH == true)
                    return "On";
                else
                    return "Off";

            }
            else
                return '-NA-';
        }
        else
            return '-NA-';
    }
}

export default reeferFormatters;